import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { LeaveSummaryState } from "@reducers/types/HRM/leave-summary-state";

import { getLeaveSummaryRequest } from "@actions/HRM/leave/leave-summary-actions";
import { getLeaveSummaryState } from "@selectors/HRM/leave/leave-summary-selector";

import { useAppSelector } from "@helpers/redux";

interface UseLeaveSummary {
  leaveBalance: any[];
}

export const useLeaveSummary = (
  employeeId: number | string
): UseLeaveSummary => {
  const leaveBalanceData = useAppSelector<LeaveSummaryState>(
    getLeaveSummaryState
  );

  const { data: leaveBalance } = leaveBalanceData || ({} as any);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getLeaveSummaryRequest(employeeId));
  }, [dispatch]);

  return {
    leaveBalance,
  };
};
